import React, { Component } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import PageTitle from '../Misc/PageTitle';
import ContentLiveCard from '../Misc/ContentLiveCard';
import ContentStatsBar from '../Misc/ContentStatsBar';
import './Bragging.css';

import WomenInTechImg from '../../Assets/Img/women-in-tech.png';
import BlogZeeNewsImg from '../../Assets/Img/blog-on-zee-news.jpg';
import AwardWinningBlogImg from '../../Assets/Img/award-winning-blogger.jpg';
import GuestWriterImg from '../../Assets/Img/guest-writer.png';

const awardHighlights = [
  {
    img: WomenInTechImg,
    title: 'Microsoft Women in Tech Initiative',
    year: '2014',
    category: 'Community & Advocacy',
    desc: 'Following appointment as a Microsoft Student Partner, drove advocacy and technical enablement sessions for women in computing across academic institutions.',
    tags: ['Microsoft', 'Advocacy', 'Community'],
  },
  {
    img: AwardWinningBlogImg,
    title: 'IndiBlogger Best Teenage Blogger',
    year: '2013',
    category: 'National Award',
    desc: 'Awarded top honors at the Indian Blogger Awards (IBA) by IndiBlogger for excellence in consumer technology journalism and hardware reviews.',
    tags: ['IndiBlogger', 'IBA 2013', 'Award'],
    link: 'https://www.indiblogger.in/iba/2013/',
    linkLabel: 'View Award',
  },
];

const mediaHighlights = [
  {
    img: BlogZeeNewsImg,
    title: 'Featured by Zee News National Media',
    year: '2013',
    category: 'Media Feature',
    desc: 'Tekdig tech publication analysis and benchmark commentary was featured on Zee News in an exclusive comparison of flagship tablet hardware.',
    tags: ['Zee News', 'National Press', 'Tech Commentary'],
    link: 'https://zeenews.india.com/exclusive/google-nexus-7-vs-ipad-mini-vs-galaxy-tab-2_6204.html',
    linkLabel: 'Read Feature',
  },
  {
    img: GuestWriterImg,
    title: 'Author on Renowned Tech Publications',
    year: '2012 – 2014',
    category: 'Tech Journalism',
    desc: 'Published articles and architectural deep-dives on top web blogs including ShoutMeLoud, Search Engine Journal, Online Income Teacher, and HellBound Bloggers.',
    tags: ['Publishing', 'Technical Writing', 'SEO'],
  },
];

const buildLinks = (item) => {
  if (!item.link) return undefined;
  return [{
    href: item.link,
    label: item.linkLabel || 'View Link',
    icon: 'fa fa-external-link',
    primary: true,
  }];
};

class Bragging extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  renderHighlight = (item, idx) => (
    <ContentLiveCard
      key={item.title}
      img={item.img}
      badge={item.category}
      year={item.year}
      title={item.title}
      desc={item.desc}
      plainTags={item.tags}
      links={buildLinks(item)}
      delay={idx * 80}
    />
  );

  render() {
    return (
      <div className="bragging-page content-page">
        <Header />

        <main id="main-content" className="section-wrapper">
          <PageTitle
            eyebrow="Recognition &amp; Milestones"
            pageTitle="Career Highlights"
            subtitle="Industry recognitions, media appearances, awards, and community contributions received across my career."
          />

          <ContentStatsBar stats={[
            { value: 4, label: 'Highlights' },
            { value: 2, label: 'Awards' },
            { value: 2, label: 'Media Features' },
          ]} />

          <div className="sc-sections">
            <section className="sc-section">
              <header className="sc-section-header">
                <h2 className="sc-section-title">Awards &amp; Community</h2>
                <p className="sc-section-desc">National recognitions and advocacy work in technology.</p>
              </header>
              <div className="sc-live-stack">
                {awardHighlights.map((item, idx) => this.renderHighlight(item, idx))}
              </div>
            </section>

            <section className="sc-section">
              <header className="sc-section-header">
                <h2 className="sc-section-title">Media &amp; Publishing</h2>
                <p className="sc-section-desc">Press features and published technical writing.</p>
              </header>
              <div className="sc-live-stack">
                {mediaHighlights.map((item, idx) => this.renderHighlight(item, idx))}
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    );
  }
}

export default Bragging;
